import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import {
  fetchUserProfile,
  updateUserProfile,
  updatePassword,
  UserProfile,
  UserProfileUpdate
} from 'api/profile'

export function useUserProfile(): UseQueryResult<UserProfile> {
  return useQuery(['user-profile'], fetchUserProfile, { staleTime: 60_000 })
}

export function useMutateUserProfile(): UseMutationResult<
  UserProfile,
  unknown,
  UserProfileUpdate
> {
  const qc = useQueryClient()
  return useMutation(updateUserProfile, {
    onSuccess: () => {
      qc.invalidateQueries(['user-profile'])
      qc.invalidateQueries(['current-user'])
    }
  })
}

export function useMutatePassword(): UseMutationResult<
  void,
  unknown,
  { currentPassword: string; newPassword: string }
> {
  return useMutation(updatePassword)
}
